import { render, staticRenderFns } from "./RequirementInfo.vue?vue&type=template&id=6cdc803c&scoped=true&"
import script from "./RequirementInfo.vue?vue&type=script&lang=js&"
export * from "./RequirementInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdc803c",
  null
  
)

export default component.exports